import Navbar from "@/pages/home/components/Navbar";
import Hero from "@/pages/home/components/Hero";
import FlashFeed from "@/pages/home/components/FlashFeed";
import Timeline from "@/pages/home/components/Timeline";
import Collection from "@/pages/home/components/Collection";
import Summary from "@/pages/home/components/Summary";
import Guide from "@/pages/home/components/Guide";
import Community from "@/pages/home/components/Community";
import Footer from "@/pages/home/components/Footer";

export default function Home() {
  return (
    <main className="min-h-screen bg-background-50 text-foreground-950">
      {/* 壳：轻杂志 + 品牌突出 */}
      <Navbar />
      {/* 首屏：文案优先、上疏 */}
      <Hero />
      {/* 下方密集内容区 */}
      <FlashFeed />
      <Timeline />
      <Collection />
      <Summary />
      <Guide />
      <Community />
      <Footer />
    </main>
  );
}